export const ENTP_CHICAGO_ECW_LOGIN_URL =
  "https://ilhncsapp.eclinicalweb.com/mobiledoc/jsp/webemr/login/newLoginStep2.jsp";

export const ENTP_REFERRAL_APPOINTMENT_DISPLAY_TIMEZONE = "America/Chicago";

export const ENTP_SUBOTO_REFERRAL_TEL_ENC_ASSIGNEE = "SUB Torres,Karina";

const ENTP_PROVIDER_EHR_ID_DISPLAY_NAMES: Record<string, string> = {
  "-IeImzx9UC5Q6WArw4qRagImd-Hyo.1-7HPiiNC8olM": "K. Kakodkar",
  "-IeImzx9UC5Q6WArw4qRaiilUIVUhNVdclvrzdppZtI": "S. Feller",
  "-IeImzx9UC5Q6WArw4qRaiwsAyiEAtCMQZVQctpkoI4": "Chicago Sleep Sleep Center",
  "-IeImzx9UC5Q6WArw4qRalnohIIZE99JKjD-dkwSM8Q": "C. Kenneally",
  "-IeImzx9UC5Q6WArw4qRalZJLMWmFOjfPlrB.7Dexxo": "M. Friedman",
  "-IeImzx9UC5Q6WArw4qRamB9J7LzD6h30.XEpBFbylA": "M. Nebel",
  "-IeImzx9UC5Q6WArw4qRan5JUA.9UFNQ8y0VDpcByRc": "J. Kelly",
  "-IeImzx9UC5Q6WArw4qRaoPQjY23XW4ibjKmMxLndZc": "M. Ahluwalia",
  "-IeImzx9UC5Q6WArw4qRaoSj8phzIkkgNnp9JsqA2vg": "J. Riel",
  "-IeImzx9UC5Q6WArw4qRaoSR8Yks2QkYi0NcXHNL3us": "K. Masella",
  "-IeImzx9UC5Q6WArw4qRapuvPmyRC4ANr-kf4QscPEc": "V. O'Reilly",
  "-IeImzx9UC5Q6WArw4qRaqajHdZGy0nXsvmdOonvNm0": "J. Friedman",
  "-IeImzx9UC5Q6WArw4qRaqtZrKNMTyAuxerFHJC2yEE": "M. Flores",
  "-IeImzx9UC5Q6WArw4qRasNps2iE6YqleSA8EJ2Nt.g": "K. Colman",
  "-IeImzx9UC5Q6WArw4qRasx5y0ae2tEng.nGSYGYI5M": "A. Levy",
  "-IeImzx9UC5Q6WArw4qRatiLfMlRyos.YABYO13VLvE": "D. Kurtzman",
  "-IeImzx9UC5Q6WArw4qRatKkZTKMADJ87wEcbG1WTP0": "K. Van Shepard",
  "-IeImzx9UC5Q6WArw4qRau38NMcN6Y4cO9OFjrHyOw4": "T. Venkatesan",
  "-IeImzx9UC5Q6WArw4qRaunTOoxgvD5Vz7B80vcIqA0": "E. May",
  "-IeImzx9UC5Q6WArw4qRaurjXyFk5SOsyAdV3tqQqU4": "A. Schubkegel",
  "-IeImzx9UC5Q6WArw4qRauSLlc4V2a1H4faxijE5grA": "M. Nassan",
  "-IeImzx9UC5Q6WArw4qRavuXMNr2fS3rh6xPN4CYE5Y": "C. Hudson",
  "122": "Michael Friedman",
  "136540": "Kathryn Colman",
  "140310": "Claire Kenneally",
  "224983": "Kirk Van Shepard",
  "253308": "Malik Nassan",
  "260468": "Jacob Friedman",
  "311023": "K. Masella",
  "9163": "T K Venkatesan",
  "9164": "Adam Levy",
};

export function getEntpProviderDisplayNameFromEhrId(providerEhrId: string | null | undefined): string {
  if (!providerEhrId) return "Unknown Provider";

  return ENTP_PROVIDER_EHR_ID_DISPLAY_NAMES[providerEhrId] ?? "Unknown Provider";
}
